import { Form, InputGroup } from 'react-bootstrap'
import React, { memo } from 'react'

import PropTypes from 'prop-types'
import { XStack } from '../../index.style'
import { useField } from 'formik'

const NumberField = ({ label, helperText, disabled, ...props }) => {
  const [field, meta] = useField(props.name)

  return (
    <Form.Group controlId={`validationFormik${field.name}`} style={{ minHeight: 128 }}>
      <XStack>
        <Form.Label as={'b'}>{label}</Form.Label>
      </XStack>
      <InputGroup hasValidation>
        <Form.Control
          type="number"
          {...field}
          {...props}
          isInvalid={meta.error && meta.touched}
          style={{ borderRadius: 16, color: 'black', backgroundColor: disabled ? '#f5f5f5' : 'white' }}
          disabled={disabled}
        />
        <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
      </InputGroup>
      <Form.Text>{helperText}</Form.Text>
    </Form.Group>
  )
}

export default memo(NumberField)

NumberField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
}
